import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NewsItem } from '../shared/models/NewsItem';
import { GlobalService } from '../shared/services/global';
import { HttpService } from '../shared/services/HttpService';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { PagingResults } from '../shared/models/PagingResult';
import { RSSItem } from '../shared/models/RSSItem';
import { User } from '../shared/models/User';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  NewsItemList: NewsItem[];
  RSSItems: RSSItem[];
  CurUser: User;
  faGlobe = faGlobe;
  ShowNewsUpdates: boolean;
  constructor(private global:GlobalService,private http:HttpService, private router:Router) { }

  ngOnInit(): void {
    this.NewsItemList = [];
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;

      if (!this.CurUser || this.CurUser == null) {
        this.router.navigate(['/']);
      } else {
        this.global.getCurrentDist().then(dist => {
          this.PostActivity(this.CurUser.UserId.toString(), "Dashboard", "Load", "", dist != null ? dist.CompanyId : "");

        });
          
        
        
        this.LoadNewsItems();
        //this.LoadRSSFeed();
      }
    });


    
    //this.LoadNewsItems();
  }

  async PostActivity(userID: string, page: string, action: string, actionValue:string,distID:string) {
    await this.http.PostUserActivity(userID, page, action,actionValue,distID);
  }


  openWindow(url: string) {
    window.open(url, '_blank');
  }

  LoadRSSFeed() {
    debugger;
    this.http.GetTolomaticRSSFeed().then(x => {
      if (x.StatusCode == "200" && x.Content) {
        this.RSSItems = x.Content;
        this.NewsItemList = [];
        for (var i = 0; i < 3; i++) {
          var newsItem = new NewsItem();
          var curItem = this.RSSItems[i];
          newsItem.CreatedDate = curItem.PublishDate;
          newsItem.Title = curItem.Title;
          newsItem.Description = curItem.Summary;
          newsItem.Link = curItem.Link;

          this.NewsItemList.push(newsItem);
        }
        //this.RSSItems.forEach(y => {
        //  var newsItem = new NewsItem();
        //  newsItem.CreatedDate = y.PublishDate;
        //  newsItem.Title = y.Title;
        //  newsItem.Description = y.Summary;
        //  newsItem.Link = y.Link;
          
        //  this.NewsItemList.push(newsItem);
        //});
      }
    });
  }

  LoadNewsItems() {
    if (this.CurUser.HasPagePermission("InfoCenter")) {
      this.ShowNewsUpdates = true;
      this.http.LoadNewsItems(3).then(wrap => {
        debugger;
        var results = <PagingResults>wrap;
        this.NewsItemList = results.Items;
      });
    }
    else {
      this.ShowNewsUpdates = false;
    }
  }

  ViewAllNews() {
    window.open("https://www.tolomatic.com/blog", '_blank');
    //this.router.navigate(['/news']);
  }



}
